import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=5cfd23d0"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cfd23d0')) {
      api.createRecord('5cfd23d0', component.options)
    } else {
      api.reload('5cfd23d0', component.options)
    }
    module.hot.accept("./Pdf.vue?vue&type=template&id=5cfd23d0", function () {
      api.rerender('5cfd23d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/fileExtensions/Pdf.vue"
export default component.exports